// Bilinguale Inhalte (DE / EN)
import { useLanguage } from "../context/LanguageContext";
import heroImg from "./pictures/hero.jpg";
import aboutImg from "./pictures/about.jpg";
import carImg from "./pictures/car.jpg";
import aiImg from "./pictures/ai.jpg";

const images = { hero: heroImg, about: aboutImg, car: carImg, ai: aiImg };

// ---------------------- DEUTSCH ----------------------
const de = {
  brand: { name: "Liesegang Consulting", initials: "LC", owner: "Stefan Liesegang" },
  brandTagline: "IT · Strategie · KI",
  nav: [
    { id: "profil", label: "Profil" },
    { id: "leistungen", label: "Leistungen" },
    { id: "fokus", label: "Fokus" },
    { id: "branchen", label: "Branchen" },
    { id: "warum", label: "Warum wir" },
    { id: "kontakt", label: "Kontakt" },
  ],
  ui: {
    contactBtn: "Kontakt",
    learnMore: "Mehr erfahren",
    services: {
      eyebrow: "Leistungen",
      titleLine1: "Vier Disziplinen.",
      titleLine2: "Ein klares Ergebnis.",
      intro:
        "Von der Architektur bis zur erfolgreichen Markteinführung – ich verbinde klassisches IT-Consulting mit moderner KI- und Datenstrategie.",
    },
    tech: {
      lead:
        "Tiefes Verständnis aktueller und kommender Technologien – von der Fahrzeugkommunikation bis zur Cloud-nativen KI-Plattform.",
    },
    industries: {
      eyebrow: "Branchenfokus",
      titleLine1: "Dort, wo Mobilität",
      titleLine2: "auf Daten trifft.",
      lead: "Tiefes Branchenwissen aus über zwei Jahrzehnten internationaler Projektarbeit.",
    },
    differentiators: {
      eyebrow: "Was mich auszeichnet",
      titleLine1: "Sechs Gründe für eine",
      titleLine2: "Zusammenarbeit.",
    },
    contact: {
      eyebrow: "Kontakt",
      labels: { location: "Standort", email: "E-Mail", linkedin: "LinkedIn", phone: "Telefon" },
      form: {
        name: "Name *",
        email: "E-Mail *",
        company: "Unternehmen",
        message: "Ihre Nachricht *",
        placeholder: "Erzählen Sie kurz von Ihrem Vorhaben …",
        consent:
          "Mit dem Absenden stimmen Sie der Verarbeitung Ihrer Angaben gemäß Datenschutzerklärung zu.",
        submit: "Nachricht senden",
        sending: "Senden …",
        sent: "Gesendet",
        validationError: "Bitte alle Pflichtfelder ausfüllen.",
        successTitle: "Nachricht gesendet",
        successDesc: "Vielen Dank – ich melde mich zeitnah.",
        savedDesc: "Vielen Dank – Ihre Nachricht wurde gespeichert.",
        errorTitle: "Fehler",
        errorDesc:
          "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
      },
    },
    footer: {
      description:
        "Beratung für IT-Architektur, Projekt- und Testmanagement sowie KI-Strategien – mit Schwerpunkt auf Automotive, Telekommunikation und digitale Mobilität.",
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      copyright: "Liesegang Consulting · Stefan Liesegang",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      close: "Schließen",
    },
    serviceDetail: {
      breadcrumbHome: "Start",
      breadcrumbServices: "Leistungen",
      primaryCta: "Projekt besprechen",
      back: "Zurück zur Übersicht",
      overview: "Überblick",
      pillarsEyebrow: "Schwerpunkte",
      pillarsTitle: "Was Sie konkret erwartet.",
      approachEyebrow: "Vorgehen",
      approachTitleLine1: "Ein klarer Pfad,",
      approachTitleLine2: "vom Start bis zum Ergebnis.",
      approachLead:
        "Jeder Schritt liefert ein konkretes Zwischenergebnis – damit Sie jederzeit Klarheit über Fortschritt, Risiken und nächste Entscheidungen haben.",
      deliverablesEyebrow: "Ihre Ergebnisse",
      deliverablesTitle: "Konkrete Liefergegenstände",
      techEyebrow: "Technologien & Methoden",
      techTitle: "Das technologische Fundament",
      useCasesEyebrow: "Beispiel-Szenarien",
      useCasesTitle: "So sieht das in der Praxis aus.",
      caseLabel: "Case",
      ctaTitle: "Passt das zu Ihrem Vorhaben?",
      ctaDesc:
        "Lassen Sie uns in einem kurzen, unverbindlichen Gespräch klären, wo Sie heute stehen und welcher nächste Schritt sinnvoll ist.",
      ctaButton: "Gespräch vereinbaren",
      nextEyebrow: "Nächste Leistung",
      nextCta: "Weiter lesen",
      notFoundTitle: "Seite nicht gefunden",
      notFoundLink: "Zur Startseite",
    },
  },
  hero: {
    eyebrow: "IT-Beratung Ingolstadt · München | Automotive · KI",
    title: "Komplexe IT-Vorhaben.\nKlar geführt.",
    subtitle:
      "Beratung für IT-Strategie, Architektur und Qualität – mit über 20 Jahren Erfahrung in internationalen IT-Projekten für Automotive, Telekommunikation und digitale Mobilität. Standort: Ingolstadt / München.",
    primaryCta: "Gespräch vereinbaren",
    secondaryCta: "Leistungen ansehen",
    stats: [
      { value: "20+", label: "Jahre Erfahrung" },
      { value: "50+", label: "Internationale Projekte" },
      { value: "3", label: "Branchenschwerpunkte" },
    ],
    badge: { title: "KI-Beratung", desc: "Use-Case bis Produktion" },
  },
  profil: {
    eyebrow: "Über mich",
    title: "Strategie. Architektur. Qualität.",
    paragraphs: [
      "Als freiberuflicher IT-Berater aus Ingolstadt unterstütze ich Unternehmen aus der Automobil- und Telekommunikationsbranche bei der Umsetzung komplexer IT-Projekte. Mein Fokus liegt auf IT-Architektur, Business-Analyse, Projekt- und Testmanagement sowie der Optimierung digitaler Geschäftsprozesse – insbesondere im Connected-Car- und eSIM-Umfeld.",
      "Mit über 20 Jahren Erfahrung in internationalen IT-Projekten helfe ich Automotive-OEMs, Tier-1-Zulieferern und Telekommunikationsunternehmen im Raum München und darüber hinaus, neue Technologien marktkonform, sicher und effizient zu integrieren – von der Konzeption bis zur erfolgreichen Einführung.",
    ],
    highlights: [
      "IT-Architektur",
      "Business-Analyse",
      "Projekt- & Testmanagement",
      "Prozess-Optimierung",
    ],
    badgeYears: "20+",
    badgeLabel: "Jahre Erfahrung in internationalen IT-Projekten",
  },
  services: [
    {
      slug: "it-architektur",
      icon: "LayoutGrid",
      title: "IT-Architektur & Systemintegration",
      desc:
        "Entwicklung skalierbarer, zukunftsfähiger IT-Landschaften – mit Fokus auf Fahrzeug-Backend-Systeme, Cloud-native Plattformen und digitale Services.",
      points: ["Cloud & Hybrid-Architekturen", "API- & Service-Design", "Security by Design"],
    },
    {
      slug: "projekt-testmanagement",
      icon: "Workflow",
      title: "Projekt- & Testmanagement",
      desc:
        "Steuerung internationaler Rollouts, Qualitätssicherung und Einführung marktspezifischer Lösungen im Connected-Car-Umfeld.",
      points: ["Agil, hybrid, klassisch", "Internationale Rollouts", "QA & Testautomatisierung"],
    },
    {
      slug: "business-analyse",
      icon: "LineChart",
      title: "Business-Analyse & Prozesse",
      desc:
        "Analyse und Neugestaltung IT-gestützter Geschäftsprozesse – methodisch fundiert mit Lean Six Sigma, Scrum und SAFe.",
      points: ["Lean Six Sigma", "Scrum & SAFe", "Prozess-Reengineering"],
    },
    {
      slug: "ki-beratung",
      icon: "Sparkles",
      title: "KI-Beratung & Datenstrategie",
      desc:
        "Sinnvolle, sichere und wirtschaftliche Integration von Künstlicher Intelligenz in bestehende Wertschöpfungsketten – von Use-Case bis Produktion.",
      points: ["KI-Use-Case-Mapping", "Daten- & MLOps-Strategie", "Verantwortungsvolle KI"],
    },
  ],
  tech: {
    eyebrow: "Technologischer Fokus",
    title: "Technologien, die Mobilität bewegen.",
    items: [
      "Connected-Car",
      "Embedded-SIM (eSIM)",
      "Cloud-Architekturen",
      "IT-Security",
      "5G & OTA",
      "Backend-Systeme",
      "Künstliche Intelligenz",
      "Daten-Plattformen",
    ],
  },
  industries: [
    {
      icon: "Car",
      title: "Automotive",
      desc: "Automobilhersteller & -zulieferer mit Schwerpunkt Connected Services, Backend-Systeme und marktkonforme Rollouts.",
    },
    {
      icon: "Radio",
      title: "Telekommunikation",
      desc: "Telekommunikationsunternehmen – von eSIM-Plattformen bis zu 5G- und OTA-getriebenen Diensten.",
    },
    {
      icon: "Zap",
      title: "Mobilität & Infrastruktur",
      desc: "IT-Dienstleister für Mobilität, Energie und kritische Infrastruktur mit hohem Anspruch an Qualität und Sicherheit.",
    },
  ],
  differentiators: [
    { icon: "GraduationCap", title: "Fundiertes Branchenwissen", desc: "Tiefes Verständnis für die Anforderungen von Automotive und Telekommunikation." },
    { icon: "Cpu", title: "Technische Tiefe", desc: "Methodische Stärke und technische Substanz – von Architektur bis Code-Review." },
    { icon: "Globe2", title: "International erfahren", desc: "Rollouts und Projekte in mehreren Märkten erfolgreich umgesetzt." },
    { icon: "Handshake", title: "Partnerschaftlich", desc: "Lösungsorientierte, langfristige Zusammenarbeit auf Augenhöhe." },
    { icon: "MapPin", title: "Nähe zum Automotive-Cluster", desc: "Standort Ingolstadt – direkt im Herzen des Automotive-Clusters Ingolstadt/München. Kurze Wege zu Audi, CARIAD, Knorr-Bremse und weiteren OEMs und Tier-1-Zulieferern." },
    { icon: "ShieldCheck", title: "Qualität & Sicherheit", desc: "Hoher Qualitätsanspruch und Security-by-Design in jedem Projekt." },
  ],
  cta: {
    title: "Bereit für den nächsten Schritt in Ihrer IT- und KI-Strategie?",
    subtitle: "Ich freue mich auf den Dialog – unverbindlich, konkret, lösungsorientiert.",
  },
  contact: {
    location: "Ingolstadt · Raum München / Süddeutschland",
    email: "stefan.liesegang@liesegang-consulting.com",
    linkedin: "https://de.linkedin.com/in/stefanliesegang",
    phone: "Auf Anfrage",
  },
  legal: {
    impressum: {
      title: "Impressum",
      sections: [
        { h: "Angaben gemäß § 5 TMG", p: "Liesegang Consulting\nInhaber: Stefan Liesegang\nRiebel-Ring 28, 85049 Ingolstadt\nDeutschland" },
        { h: "Kontakt", p: "E-Mail: stefan.liesegang@liesegang-consulting.com\nWeb: https://liesegang-consulting.com" },
        { h: "Umsatzsteuer-ID", p: "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE455907636" },
        { h: "Haftung für Inhalte", p: "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen." },
        { h: "Haftung für Links", p: "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte übernehmen wir keine Gewähr." },
        { h: "Urheberrecht", p: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht." },
      ],
    },
    datenschutz: {
      title: "Datenschutzerklärung",
      intro: "Angaben gemäß Art. 13 DSGVO",
      sections: [
        { h: "1. Verantwortlicher", p: "Liesegang Consulting\nInhaber: Stefan Liesegang\nRiebel-Ring 28, 85049 Ingolstadt Deutschland\nE-Mail: stefan.liesegang@liesegang-consulting.com" },
        { h: "2. Erhebung und Speicherung personenbezogener Daten", p: "Beim Besuch der Website werden automatisch Informationen durch den Browser des Nutzers an den Server der Website gesendet. Diese Informationen werden temporär in einem sogenannten Logfile gespeichert: IP-Adresse, Datum und Uhrzeit, Name und URL der abgerufenen Datei, Referrer-URL, Browser und Betriebssystem." },
        { h: "3. Weitergabe von Daten", p: "Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen Zwecken findet nicht statt, außer mit ausdrücklicher Einwilligung, zur Vertragsabwicklung, rechtlichen Verpflichtung oder zur Wahrung berechtigter Interessen." },
        { h: "4. Betroffenenrechte", p: "Sie haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20) sowie auf Beschwerde bei der Aufsichtsbehörde (Art. 77 DSGVO)." },
        { h: "5. Widerspruchsrecht", p: "Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen verarbeitet werden, haben Sie gemäß Art. 21 DSGVO das Recht auf Widerspruch." },
        { h: "6. Datensicherheit", p: "Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird." },
      ],
    },
  },
  images,
};

// ---------------------- ENGLISH ----------------------
const en = {
  brand: { name: "Liesegang Consulting", initials: "LC", owner: "Stefan Liesegang" },
  brandTagline: "IT · Strategy · AI",
  nav: [
    { id: "profil", label: "Profile" },
    { id: "leistungen", label: "Services" },
    { id: "fokus", label: "Focus" },
    { id: "branchen", label: "Industries" },
    { id: "warum", label: "Why us" },
    { id: "kontakt", label: "Contact" },
  ],
  ui: {
    contactBtn: "Contact",
    learnMore: "Learn more",
    services: {
      eyebrow: "Services",
      titleLine1: "Four disciplines.",
      titleLine2: "One clear outcome.",
      intro:
        "From architecture to successful market launch – I combine classic IT consulting with modern AI and data strategy.",
    },
    tech: {
      lead:
        "A deep understanding of current and emerging technologies – from in-vehicle communication to cloud-native AI platforms.",
    },
    industries: {
      eyebrow: "Industry focus",
      titleLine1: "Where mobility",
      titleLine2: "meets data.",
      lead: "Deep industry expertise from more than two decades of international project work.",
    },
    differentiators: {
      eyebrow: "What sets me apart",
      titleLine1: "Six reasons to",
      titleLine2: "work together.",
    },
    contact: {
      eyebrow: "Contact",
      labels: { location: "Location", email: "Email", linkedin: "LinkedIn", phone: "Phone" },
      form: {
        name: "Name *",
        email: "Email *",
        company: "Company",
        message: "Your message *",
        placeholder: "Briefly tell me about your initiative …",
        consent:
          "By submitting, you agree to the processing of your data in accordance with the privacy policy.",
        submit: "Send message",
        sending: "Sending …",
        sent: "Sent",
        validationError: "Please fill in all required fields.",
        successTitle: "Message sent",
        successDesc: "Thank you – I will be in touch shortly.",
        savedDesc: "Thank you – your message has been saved.",
        errorTitle: "Error",
        errorDesc: "Something went wrong while sending. Please try again later.",
      },
    },
    footer: {
      description:
        "Consulting for IT architecture, project and test management, and AI strategies – with a focus on automotive, telecommunications and digital mobility.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      copyright: "Liesegang Consulting · Stefan Liesegang",
      impressum: "Legal notice",
      datenschutz: "Privacy",
      close: "Close",
    },
    serviceDetail: {
      breadcrumbHome: "Home",
      breadcrumbServices: "Services",
      primaryCta: "Discuss your project",
      back: "Back to overview",
      overview: "Overview",
      pillarsEyebrow: "Focus areas",
      pillarsTitle: "What you can specifically expect.",
      approachEyebrow: "Approach",
      approachTitleLine1: "A clear path,",
      approachTitleLine2: "from start to result.",
      approachLead:
        "Every step delivers a tangible interim result – so you have clarity on progress, risks and the next decision at any time.",
      deliverablesEyebrow: "Your results",
      deliverablesTitle: "Concrete deliverables",
      techEyebrow: "Technologies & methods",
      techTitle: "The technological foundation",
      useCasesEyebrow: "Example scenarios",
      useCasesTitle: "What this looks like in practice.",
      caseLabel: "Case",
      ctaTitle: "Is this a fit for your initiative?",
      ctaDesc:
        "Let's have a brief, no-obligation conversation about where you stand today and the right next step for you.",
      ctaButton: "Schedule a call",
      nextEyebrow: "Next service",
      nextCta: "Read more",
      notFoundTitle: "Page not found",
      notFoundLink: "Back to home",
    },
  },
  hero: {
    eyebrow: "IT · Strategy · AI Consulting",
    title: "Complex IT initiatives.\nClearly led.",
    subtitle:
      "Consulting for strategy, architecture and quality – with more than 20 years of experience delivering international IT projects for automotive, telecommunications and digital mobility.",
    primaryCta: "Schedule a call",
    secondaryCta: "Explore services",
    stats: [
      { value: "20+", label: "Years of experience" },
      { value: "50+", label: "International projects" },
      { value: "3", label: "Industry focus areas" },
    ],
    badge: { title: "AI Consulting", desc: "Use case to production" },
  },
  profil: {
    eyebrow: "About me",
    title: "Strategy. Architecture. Quality.",
    paragraphs: [
      "I support companies in the automotive and telecommunications industries in delivering complex IT projects. My focus is on IT architecture, business analysis, project and test management, and the optimization of digital business processes.",
      "With more than 20 years of experience in international projects, I help my clients integrate new technologies in a market-ready, secure and efficient way – from concept to successful rollout.",
    ],
    highlights: [
      "IT Architecture",
      "Business Analysis",
      "Project & Test Management",
      "Process Optimization",
    ],
    badgeYears: "20+",
    badgeLabel: "years of experience in international IT projects",
  },
  services: [
    {
      slug: "it-architektur",
      icon: "LayoutGrid",
      title: "IT Architecture & System Integration",
      desc:
        "Designing scalable, future-ready IT landscapes – with a focus on vehicle backend systems, cloud-native platforms and digital services.",
      points: ["Cloud & hybrid architectures", "API & service design", "Security by design"],
    },
    {
      slug: "projekt-testmanagement",
      icon: "Workflow",
      title: "Project & Test Management",
      desc:
        "Leading international rollouts, quality assurance and market-specific introduction of solutions in the connected-car space.",
      points: ["Agile, hybrid, classic", "International rollouts", "QA & test automation"],
    },
    {
      slug: "business-analyse",
      icon: "LineChart",
      title: "Business Analysis & Processes",
      desc:
        "Analysis and redesign of IT-supported business processes – methodically grounded in Lean Six Sigma, Scrum and SAFe.",
      points: ["Lean Six Sigma", "Scrum & SAFe", "Process re-engineering"],
    },
    {
      slug: "ki-beratung",
      icon: "Sparkles",
      title: "AI Consulting & Data Strategy",
      desc:
        "Meaningful, secure and economic integration of artificial intelligence into existing value chains – from use case to production.",
      points: ["AI use-case mapping", "Data & MLOps strategy", "Responsible AI"],
    },
  ],
  tech: {
    eyebrow: "Technology focus",
    title: "Technologies that move mobility.",
    items: [
      "Connected Car",
      "Embedded SIM (eSIM)",
      "Cloud architectures",
      "IT Security",
      "5G & OTA",
      "Backend systems",
      "Artificial intelligence",
      "Data platforms",
    ],
  },
  industries: [
    {
      icon: "Car",
      title: "Automotive",
      desc: "Automotive OEMs and suppliers with a focus on connected services, backend systems and market-ready rollouts.",
    },
    {
      icon: "Radio",
      title: "Telecommunications",
      desc: "Telecom providers – from eSIM platforms to 5G- and OTA-driven services.",
    },
    {
      icon: "Zap",
      title: "Mobility & Infrastructure",
      desc: "IT service providers for mobility, energy and critical infrastructure with high demands on quality and security.",
    },
  ],
  differentiators: [
    { icon: "GraduationCap", title: "Deep industry knowledge", desc: "A thorough understanding of the requirements of automotive and telecommunications." },
    { icon: "Cpu", title: "Technical depth", desc: "Methodical strength and technical substance – from architecture to code review." },
    { icon: "Globe2", title: "International experience", desc: "Successful delivery of rollouts and projects across multiple markets." },
    { icon: "Handshake", title: "Partnership-oriented", desc: "Solution-oriented, long-term collaboration on equal footing." },
    { icon: "MapPin", title: "Close to the cluster", desc: "Located near Ingolstadt / Munich – at the heart of the automotive cluster." },
    { icon: "ShieldCheck", title: "Quality & security", desc: "High quality standards and security-by-design in every project." },
  ],
  cta: {
    title: "Ready for the next step in your IT and AI strategy?",
    subtitle: "I look forward to the conversation – informal, concrete and solution-oriented.",
  },
  contact: {
    location: "Ingolstadt · Munich area / Southern Germany",
    email: "stefan.liesegang@liesegang-consulting.com",
    linkedin: "https://de.linkedin.com/in/stefanliesegang",
    phone: "On request",
  },
  legal: {
    impressum: {
      title: "Legal notice (Impressum)",
      sections: [
        { h: "Information according to § 5 TMG", p: "Liesegang Consulting\nOwner: Stefan Liesegang\nRiebel-Ring 28, 85049 Ingolstadt\nGermany" },
        { h: "Contact", p: "Email: stefan.liesegang@liesegang-consulting.com\nWeb: https://liesegang-consulting.com" },
        { h: "VAT ID", p: "VAT identification number according to § 27 a German VAT Act: DE455907636" },
        { h: "Liability for content", p: "As a service provider, we are responsible for our own content on these pages in accordance with general law (§ 7 para. 1 TMG). According to §§ 8 to 10 TMG, we are not obliged to monitor transmitted or stored third-party information or to investigate circumstances indicating illegal activity." },
        { h: "Liability for links", p: "Our offer contains links to external websites of third parties whose content we have no influence over. We accept no liability for this external content." },
        { h: "Copyright", p: "The content and works on these pages created by the site operators are subject to German copyright law." },
        { h: "Note", p: "The German version of this notice is the legally binding one." },
      ],
    },
    datenschutz: {
      title: "Privacy policy",
      intro: "Information according to Art. 13 GDPR",
      sections: [
        { h: "1. Controller", p: "Liesegang Consulting\nOwner: Stefan Liesegang\nRiebel-Ring 28, 85049 Ingolstadt, Germany\nEmail: stefan.liesegang@liesegang-consulting.com" },
        { h: "2. Collection and storage of personal data", p: "When you visit the website, the user's browser automatically sends information to the website's server. This information is temporarily stored in a log file: IP address, date and time, name and URL of the file accessed, referrer URL, browser and operating system." },
        { h: "3. Disclosure of data", p: "Your personal data will not be passed on to third parties for purposes other than those listed, except with your explicit consent, to fulfil a contract, due to legal obligation or to protect legitimate interests." },
        { h: "4. Rights of data subjects", p: "You have the right to information (Art. 15), rectification (Art. 16), erasure (Art. 17), restriction (Art. 18), data portability (Art. 20) and to lodge a complaint with the supervisory authority (Art. 77 GDPR)." },
        { h: "5. Right to object", p: "If your personal data is processed on the basis of legitimate interests, you have the right to object pursuant to Art. 21 GDPR." },
        { h: "6. Data security", p: "We use SSL during your visit in combination with the highest encryption level supported by your browser." },
        { h: "Note", p: "The German version of this privacy policy is the legally binding one." },
      ],
    },
  },
  images,
};

export const siteContentByLang = { de, en };

export function useSiteContent() {
  const { lang } = useLanguage();
  return siteContentByLang[lang] || siteContentByLang.de;
}
